module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"averageticket":"Average ticket"},"es":{"averageticket":"Ticket medio"}}')
  delete Component.options._Ctor
}
